<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav v-if="hadLoaded" ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <div v-if="hadLoaded">
          <!-- logo -->
          <div class="logo">
              <a href="/"><img src="../assets/logo.png" /></a>
          </div>
          <!-- CN|EN -->
          <language @custom-event="handleChildEvent" />
          <!-- 产品名称 -->
          <div class="product_name" v-if="upperActive != null && downActive != null && outerActive != null">
            <p v-if="lang == 'cn'">{{ upperObj[upperActive].showtext }}-{{ downObj[downActive].showtext }}-衣架{{outerObj[outerActive].showtext}}</p>
            <p v-if="lang == 'en'">{{ upperObj[upperActive].en_showtext }}-{{ downObj[downActive].en_showtext }}-Coat hanger{{outerObj[outerActive].en_showtext}}</p>
          </div>
          <!-- 弹框 -->
          <!-- :modal="false" 关闭遮罩层-->
          <el-dialog
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            width="30%"
            :show-close="false"
            >
            <img :src="Product_introduce.image" alt="" srcset="" class="dialogimg" v-if="Product_introduce.image">
            <span v-if="Product_introduce.text && lang == 'cn'">{{Product_introduce.text}}</span>
            <span v-if="Product_introduce.text && lang == 'en'">{{Product_introduce.en_text}}</span>
            <!-- <span slot="footer" class="dialog-footer"> -->
              <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
              <!-- <el-button type="danger" @click="dialogVisible = false">确 定</el-button> -->
            <!-- </span> -->
          </el-dialog>
          <!-- 菜单栏 -->
          <div class="app-toolbar">
              <div class="app-toolbar-circle">
                  <div class="ring"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                      <g class="ring">
                          <g class="toolbar-item" @click="openLink()">
                              <path
                                  d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="16px" x="36" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                              <path
                                  d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1032">上 模</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="16px" x="2" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1032">Upper die body</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                              <path
                                  d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1000">下 模</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="16px" x="5" @mouseenter="greet" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1000">Lower die body</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                              <path
                                  d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1001">外 挡</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="15px" x="5" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1001">External deckling</textPath>
                              </text>
                          </g>
                      </g>
                      <defs>
                          <path id="SvgjsPath1000"
                              d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                          </path>
                          <path id="SvgjsPath1001"
                              d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                          </path>
                          <path id="SvgjsPath1031"
                              d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                          </path>
                          <path id="SvgjsPath1032"
                              d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                          </path>
                      </defs>
                  </svg>
              </div>
              <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
                  <!-- <template v-for="item in upperObj"> -->
                      <div
                        v-for="(item,index) in upperObj"
                        :key="index"
                        :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                        @click="upperAnimate(item)"
                      >
                          <template v-if="lang == 'cn'">
                              {{ item.text }}
                          </template>
                          <template v-if="lang == 'en'">
                              {{ item.en_text }}
                          </template>
                      </div>
                      <div
                        :class="[{'active':cebanstatus === false}, 'app-submenu-item']"
                        @click="removeceban()"
                      >
                          <template v-if="lang == 'cn' && cebanstatus == true">
                              去侧板
                          </template>
                          <template v-if="lang == 'cn' && cebanstatus == false">
                              加侧板
                          </template>
                          <template v-if="lang == 'en' && cebanstatus == true">
                              Without side plates
                          </template>
                          <template v-if="lang == 'en' && cebanstatus == false">
                              With side plates
                          </template>
                      </div>
                  <!-- </template> -->
              </div>
              <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                  <!-- <template v-for="item in downObj"> -->
                      <div
                        v-for="(item,index) in downObj"
                        :key="index"
                        :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                        @click="downAnimate(item)"
                      >
                          <template v-if="lang == 'cn'">
                              {{ item.text }}
                          </template>
                          <template v-if="lang == 'en'">
                              {{ item.en_text }}
                          </template>
                      </div>
                      <div
                        :class="[{'active':cebanstatus === false}, 'app-submenu-item']"
                        @click="removeceban()"
                      >
                          <template v-if="lang == 'cn' && cebanstatus == true">
                              去侧板
                          </template>
                          <template v-if="lang == 'cn' && cebanstatus == false">
                              加侧板
                          </template>
                          <template v-if="lang == 'en' && cebanstatus == true">
                              without side plates
                          </template>
                          <template v-if="lang == 'en' && cebanstatus == false">
                              with side plates
                          </template>
                      </div>
                  <!-- </template> -->
              </div>
              <div class="app-submenu-wrap img-wrap" v-if="toobarActive === 'outer'">
                  <!-- <template v-for="(item,index) in outerObj" :key="index"> -->
                      <div
                         v-for="(item,index) in outerObj"
                        :key="index"
                        :class="[{'active':outerActive == item.id}, 'app-submenu-item']"
                        @click="outerAnimate(item)"
                      >
                          <template v-if="lang == 'cn'">
                              {{ item.text }}
                          </template>
                          <template v-if="lang == 'en'">
                              {{ item.en_text }}
                          </template>
                      </div>
                  <!-- </template> -->
              </div>
          </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // 引入CSS3渲染器CSS3DRenderer
    // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';
    var scene;

    export default {

        components: {
            Loader,
            Nav,
            language,
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型

                toobarActive: null, // 工具栏状态

                upperActive: null, //上模零件 下标
                downActive: null, // 下模零件
                outerActive: -1, // 外挡零件
                is_hidenote:true,


                labelRenderer:null, // CSS2渲染器
                upperhtmldimension:null, // 上模HTML标注
                downhtmldimension:null, // 下模HTML标注
                outerhtmldimension:null, // 外挡HTML标注
                removehtmldimension:null, // 移除侧板HTML标注

                cebanstatus:true, //侧板状态(开true/关false)
                // caiClips: null, // 拆卸动画合集
                // heClips: null, // 装配动画合集
                // versionClips: null, // 切换版本动画合集

                composer:null, // 处理对象EffectComposer
                outlinePass:null,// 后处理描边对象
                antiShake:null, // 防抖对象
                dialogVisible: false, //弹出框是否显示
                changecebanid:1, //隐藏的侧板编号
                // localPlaneCommon: new THREE.Plane(new THREE.Vector3(0, 1, 0), 10), // 剖面

                lang: 'cn', // 语言
                Product_introduce:{
                  text:'',
                  en_text:'',
                  image:'',
                },
                Product_info:{
                  'upper':{
                    text:'',
                    image:'',
                  },
                  'down':{
                    text:'',
                    image:'',
                  },
                  'outer':{
                    text:'',
                    image:'',
                  }
                },
                upperObj:[ //上模选项
                  {
                      id: 0,
                      text: '推式', //菜单显示
                      en_text: 'Push only adjustment', //菜单显示(英文)
                      showtext: '手动推式', //页面显示的名称
                      en_showtext: 'Push only adjustment', //页面显示的名称(英文)
                      modelname:"shoudongtuishi", //模型零件名称
                      coordinate_list:[-4.8, 1.3, -0.6], //标注坐标
                      Product_info:{ //产品介绍内容
                        text:'推式微调：单向调节；模唇调节范围为0~1mm',
                        en_text:'Push only adjustment: one-way adjustment, with adjustment range of 0-1mm',
                        image:require('../assets/images/pcmt_ts.jpg'),
                      },
                  },
                  {
                      id: 1,
                      text: '推拉式',
                      showtext: '手动推拉式',
                      en_showtext: 'Push & pull adjustment',
                      en_text: 'Push & pull adjustment',
                      modelname:'shoudongtuilashi',
                      coordinate_list:[-4.8, 1.6, -0.3], //标注坐标
                      Product_info:{
                        text:'推拉式微调：双向可调；模唇调节范围为±1mm',
                        en_text:'Push pull fine adjustment: bi-directional adjustable; The adjustment range of the mold lip is ± 1mm',
                        image:require('../assets/images/pcmt_tls.jpg'),
                      },
                  },
                ],
                downObj: [ //下模选项
                  {
                      id: 0,
                      text: '整体',
                      showtext: '下模整体(45°)',
                      en_showtext: 'Monoblock structure (45 °)',
                      en_text: 'Monoblock structure',
                      modelname:'xiamozhengti',
                      coordinate_list:[0, -0.6, -1.6],
                      Product_info:{
                        text:'整体式下模：适用于单一厚度制品的模头',
                        en_text:'Lower die body in monoblock structure: applied to dies which are producing sheet with monotonous thickness',
                        image:require('../assets/images/pcmt_xiamo_zt.jpg'),
                      },
                  },
                  {
                      id: 1,
                      text: '固定',
                      showtext: '下模固定',
                      en_showtext: 'Fixed type structure',
                      en_text: 'Fixed type structure',
                      modelname:'xiamoguding',
                      coordinate_list:[0, -0.6, -1.6],
                      Product_info:{
                        text:'固定式下模：模唇部分可独立拆卸和更换',
                        en_text:'Lower die body in fixed type structure: die lip is removable and interchangeable',
                        image:require('../assets/images/pcmt_xiamo_gd.jpg'),
                      },
                  },
                  {
                      id: 2,
                      text: '预调',
                      showtext: '下模粗调',
                      en_showtext: 'Pre-adjusting structure',
                      en_text: 'Pre-adjusting structure',
                      modelname:"xiamocutiao",
                      coordinate_list:[0, -0.6, -1.6],
                      Product_info:{
                        text:'可调式下模：模唇部分可滑动调节',
                        en_text:'Lower die body in adjustable structure: die lip is adjustable',
                        image:require('../assets/images/pcmt_xiamo_ct.jpg'),
                      },
                  }
                ],
                outerObj: [ // 外挡选项
                  {
                      id: 0,
                      text: '无',
                      showtext: '',
                      en_text: 'Null',
                      modelname:null,
                      coordinate_list:null,
                      Product_info:null,
                  },
                  {
                      id: 1,
                      text: 'C型',
                      showtext: '-普通外挡100',
                      en_showtext: '-C type',
                      en_text: 'C type',
                      modelname:'waidang',
                      coordinate_list:[-4.5, 0, -2.5],
                      Product_info:{
                        text:'挂钩外挡：可阻挡出料口，调节出料宽度',
                        en_text:'Hook type external deckling: to adjust the product width by blocking the edges',
                        image:require('../assets/images/wd.png'),
                      },
                  },
                ],
                cebanObj:{
                  coordinate_list:[-60, 0, 0], //标注坐标
                }
            }
        },

        mounted: function () {

            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            this.raycasterclick()
            // this.initPostprocessing(); // 初始化后期处理
            // this.lighteffect()
            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language'); // 存入一个值
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
            let _this = this;

            _this.container = this.$refs.webgl;
            _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
            _this.containerH = this.$refs.webgl.getBoundingClientRect().height;

            _this.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: true
            });
            _this.renderer.setSize(this.containerW,this.containerH);
            _this.renderer.localClippingEnabled = true;
            _this.renderer.clippingPlanes = Object.freeze([])
            _this.renderer.setClearAlpha(0);
            _this.renderer.setPixelRatio(window.devicePixelRatio);
            _this.renderer.outputEncoding = THREE.sRGBEncoding;
            _this.container.appendChild(_this.renderer.domElement);
            // 调整曝光度
            _this.renderer.toneMapping =THREE.CineonToneMapping
            _this.renderer.toneMappingExposure=0.75
            // 创建一个CSS2渲染器CSS2DRenderer
            // _this.labelRenderer = new CSS2DRenderer();
            // _this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
            // // 相对标签原位置位置偏移大小
            // _this.labelRenderer.domElement.style.position = 'absolute';
            // _this.labelRenderer.domElement.style.top = '0px';
            // _this.labelRenderer.domElement.style.left = '0px';
            // //设置.pointerEvents=none，以免模型标签HTML元素遮挡鼠标选择场景模型
            // _this.labelRenderer.domElement.style.pointerEvents = 'none';
            // _this.$refs.webgl.appendChild( _this.labelRenderer.domElement);
          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;

              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 3000);
            if(window.innerWidth > 996){
              _this.camera.position.set(0, 0, 150);
            }else{
              _this.camera.position.set(0, 0, 300);
            }
            _this.camera.lookAt(_this.scene.position);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;

              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enableDamping = true; //启用阻尼（惯性）
              _this.controls.dampingFactor = 0.1; //阻尼惯性有多大
              _this.controls.maxPolarAngle = Math.PI; //你能够垂直旋转的角度的上限
              _this.controls.minPolarAngle = 0; //你能够垂直旋转的角度的下限
              _this.controls.enablePan = false; //启用或禁用摄像机平移
              // _this.controls.enableZoom = true; //启用或禁用摄像机的缩放。

              _this.controls.minDistance = 70;
              _this.controls.maxDistance = 300;
          },

          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            // let loaderRGBE = new EXRLoader();
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/marry_hall_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;

              // texture.mapping = THREE.EquirectangularReflectionMapping;
              // _this.scene.background = texture;
              // _this.scene.environment = texture;

              texture.dispose();
              pmremGenerator.dispose();
            })
          },
          lighteffect(){  //灯光效果
            const ambientlight = new THREE.AmbientLight( 0xffffff,0.1 ); // soft white light
            // const light = new THREE.DirectionalLight( 0xffffff, 0.5);
            // light.position.set( 0, -80, 0 );
            // this.scene.add( light );
            this.scene.add( ambientlight );
          },
          /**
           * @description 加载模型文件
           */
          loadModel: function() {
            try {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();
              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/pcmt/pcmt.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.model.traverse(function(child) {
                    // console.log(child.name)
                    if(child.material){
                      // child.material.clippingPlanes = [_this.localPlaneCommon];
                    }
                });
                // 将模型的旋转设置为(0, Math.PI / 2, 0)，即绕Y轴旋转90度
                _this.model.rotateY(Math.PI);
                _this.upperAnimate(_this.upperObj[0],false)
                _this.downAnimate(_this.downObj[0],false)
                _this.outerAnimate(_this.outerObj[1],false)
                _this.model.scale.set(10, 10, 10);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.animate();

              },
              function (xhr) {
                // console.log(xhr);
              },
              function (err) {
                alert(err,'loader_err');
              });
            } catch (error) {
              alert(error,'try_err')
            }
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();

            // if (_this.clippingPlanesStatus) {
            //     _this.localPlane1.constant += _this.step;
            //     _this.localPlane3.constant += 0.25;

            // }
            // let mixerUpdateDelta = _this.clock.getDelta();
            // _this.mixer.update( mixerUpdateDelta );
            // _this.composer.render(); // 使用后处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            // 如果有正在运行的动画，不执行新动画
              // if (TWEEN.getAll().length > 0) {
              //   console.log("动画正在运行，请稍后再试");
              //   return;
              // }
              let _this = this;
              if ( _this.toobarActive == e ) {
                  _this.toobarActive = '';
              }else{
                _this.toobarActive = e;
                var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
                }
                var oldT = { //旧的聚焦位置
                  x: _this.controls.target.x,
                  y: _this.controls.target.y,
                  z: _this.controls.target.z,
                }
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                if (e == 'upper') {
                  var newP = { //新的相机位置
                    x: 0,
                    y: 150,
                    z: 10,
                  }
                  _this.tweenCamera(oldP, oldT, newP, newT);
                }else if(e == 'down'){
                  var newP = { //新的相机位置
                    x: 0,
                    y: -40,
                    z: 140,
                  }
                  _this.tweenCamera(oldP, oldT, newP, newT);
                }else if(e == 'outer'){
                  var newP = { //新的相机位置
                    x: 0,
                    y: 0,
                    z: 150,
                  }
                  _this.tweenCamera(oldP, oldT, newP, newT);
                }
              }
          },

          /**
           * @description 选择上模
           * @param {number} e 零件型号
           * @param {isload} e 是否为手动点击
           */
          upperAnimate: function(item,isload=true) {
            let _this = this;
            _this.upperActive = item.id;
            if(this.camera.position !={x:0,y:0,z:1500} && isload ){
              var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 150,
                z: 10,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
            if(item.Product_info){
              _this.Product_info.upper = item.Product_info
            }
            //=======================================添加标注=======================================//
            if(_this.upperhtmldimension){ //移除原先的标注
              _this.model.remove(_this.upperhtmldimension)
            }
            if(item.coordinate_list){
              const texture = new THREE.TextureLoader().load("../../static/image/click.png");
              console.log(texture);
              // 创建精灵材质对象SpriteMaterial
              const spriteMaterial = new THREE.SpriteMaterial({
                color:0xff0000,//设置颜色
                map: texture, //设置精灵纹理贴图
              });
              // 创建精灵模型对象，不需要几何体geometry参数
              // const sprite = new THREE.Sprite(spriteMaterial);
              _this.upperhtmldimension = new THREE.Sprite(spriteMaterial);
              _this.upperhtmldimension.scale.set(0.3,0.3);  // 标注缩放
              _this.upperhtmldimension.name='upperhtmldimension';
              _this.upperhtmldimension.position.set(...item.coordinate_list);  // 标注坐标
              this.model.add(_this.upperhtmldimension);
            }
            //=======================================添加标注=======================================//
            for (let i = 0; i < _this.upperObj.length; i++) {
              if(item.modelname == _this.upperObj[i].modelname){
                _this.model.getObjectByName(_this.upperObj[i].modelname).visible = true;
                // if(isload){
                //   _this.outlinePass.selectedObjects = [_this.model.getObjectByName(item.modelname)]; // 添加需要描边的模型

                //   if(_this.antiShake !== null){ //防抖
                //     clearTimeout(_this.antiShake);
                //   }
                //   _this.antiShake = setTimeout(() => {
                //     _this.outlinePass.selectedObjects = []; // 3s后删除描边
                //   }, 3000);
                // }
              }else{
                _this.model.getObjectByName(_this.upperObj[i].modelname).visible = false;
              }
            }
          },

          /**
           * @description 选择下模
           * @param {Number} e 下模型号
           * @param {isload} e 是否为手动点击
           */
          downAnimate: function(item,isload=true) {
            let _this = this;
            _this.downActive = item.id;
            if(this.camera.position !={x:0,y:0,z:-1500} && isload ){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: -40,
                z: 140,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
            if(item.Product_info){
              _this.Product_info.down = item.Product_info
            }
            //=======================================添加标注=======================================//
            if(_this.downhtmldimension){ //移除原先的标注
              _this.model.remove(_this.downhtmldimension)
            }
            if(item.coordinate_list){
              const texture = new THREE.TextureLoader().load("../../static/image/click.png");
              // 创建精灵材质对象SpriteMaterial
              const spriteMaterial = new THREE.SpriteMaterial({
                color:0xff0000,//设置颜色
                map:texture
              });
              // 创建精灵模型对象，不需要几何体geometry参数
              // const sprite = new THREE.Sprite(spriteMaterial);
              _this.downhtmldimension = new THREE.Sprite(spriteMaterial);
              _this.downhtmldimension.scale.set(0.3,0.3);  // 标注坐标
              _this.downhtmldimension.name='downhtmldimension';  // 标注坐标
              _this.downhtmldimension.position.set(...item.coordinate_list);  // 标注坐标
              this.model.add(_this.downhtmldimension);

            }
            //=======================================添加标注=======================================//
            if(item.id == 2){
              _this.model.getObjectByName("xiamocutiaoceban").visible = true
              _this.model.getObjectByName("ceban").visible = false
              _this.model.getObjectByName("xiamocutiaoceban").visible = _this.cebanstatus
            }else{
              _this.model.getObjectByName("xiamocutiaoceban").visible = false
              _this.model.getObjectByName("ceban").visible = true
              _this.model.getObjectByName("ceban").visible = _this.cebanstatus
            }
            for (let i = 0; i < _this.downObj.length; i++) {
              if(item.modelname == _this.downObj[i].modelname){
                _this.model.getObjectByName(_this.downObj[i].modelname).visible = true;
                if(_this.downObj[i].id == 2){
                  _this.changecebanid = 2
                }else{
                  _this.changecebanid = 1
                }
                // if(isload){
                //   _this.outlinePass.selectedObjects = [_this.model.getObjectByName(item.modelname)]; // 添加需要描边的模型
                //   if(_this.antiShake !== null){
                //     clearTimeout(_this.antiShake);
                //   }
                //   _this.antiShake = setTimeout(() => {
                //     _this.outlinePass.selectedObjects = []; // 3s后删除描边
                //   }, 3000);
                // }
              }else{
                _this.model.getObjectByName(_this.downObj[i].modelname).visible = false;
              }
            }
          },

          /**
           * @description 选择外挡
           * @param {number} e 外挡型号
           * @param {isload} e 是否为手动点击
           */
          outerAnimate: function(item,isload=true) {
            // 如果有正在运行的动画，不执行新动画
            // if (TWEEN.getAll().length > 0) {
            //     console.log("动画正在运行，请稍后再试");
            //     return;
            // }
            let _this = this;
            _this.outerActive = item.id;
            if(this.camera.position !={x:0,y:-1500,z:300} && isload ){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 150,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
            if(item.Product_info){
              _this.Product_info.outer = item.Product_info
            }
            //=======================================添加标注=======================================//
            if(_this.outerhtmldimension){ //移除原先的标注
              _this.model.remove(_this.outerhtmldimension)
            }
            if(item.coordinate_list){ //添加标注
                const texture = new THREE.TextureLoader().load("../../static/image/click.png");
                // 创建精灵材质对象SpriteMaterial
                const spriteMaterial = new THREE.SpriteMaterial({
                  color:0xff0000,//设置颜色
                  map:texture
                });
                // 创建精灵模型对象，不需要几何体geometry参数
                // const sprite = new THREE.Sprite(spriteMaterial);
                _this.outerhtmldimension = new THREE.Sprite(spriteMaterial);
                _this.outerhtmldimension.scale.set(0.3,0.3);  // 标注坐标
                _this.outerhtmldimension.name='outerhtmldimension';  // 标注坐标
                _this.outerhtmldimension.position.set(...item.coordinate_list);  // 标注坐标
                this.model.add(_this.outerhtmldimension);
              }
            //=======================================添加标注=======================================//
            for (let i = 0; i < _this.outerObj.length; i++) {
              if(item.modelname == _this.outerObj[i].modelname && _this.model.getObjectByName(_this.outerObj[i].modelname)){ //选中的零件名称匹配 且 名称存在
                _this.model.getObjectByName(_this.outerObj[i].modelname).visible = true; //显示零件
                // if(isload){
                //   _this.outlinePass.selectedObjects = [_this.model.getObjectByName(item.modelname)]; // 添加需要描边的模型
                //   if(_this.antiShake !== null){
                //     clearTimeout(_this.antiShake);
                //   }
                //   _this.antiShake = setTimeout(() => {
                //     _this.outlinePass.selectedObjects = []; // 3s后删除描边
                //   }, 3000);
                // }
              }else{ //选中的零件名称不匹配
                if(_this.model.getObjectByName(_this.outerObj[i].modelname)){ //零件名称存在
                  _this.model.getObjectByName(_this.outerObj[i].modelname).visible = false;  //隐藏零件
                }
              }
            }
          },

          /**
           * @description 初始化后处理
           */
          initPostprocessing() {
            let _this = this;
            // 创建后处理对象EffectComposer，WebGL渲染器作为参数
            _this.composer = new EffectComposer(_this.renderer);
            // 创建一个渲染器通道，场景和相机作为参数
            const renderPass = new RenderPass(_this.scene, _this.camera);
            // 设置renderPass通道
            _this.composer.addPass(renderPass);
            // 使用OutlinePass，添加描边效果
            _this.outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), _this.scene, _this.camera);
            _this.outlinePass.edgeStrength = 5; // 描边发光强度设置
            _this.outlinePass.edgeGlow  = 0; // 描边边缘发光的强度
            _this.outlinePass.edgeThickness = 2; //描边厚度设置
            _this.outlinePass.pulsePeriod = 1; // 描边的闪烁频率 (n秒/一次)
            _this.outlinePass.visibleEdgeColor.set('#ff0000'); //边框的可见部分的颜色
            _this.outlinePass.hiddenEdgeColor.set('#ff0000'); //
            _this.composer.addPass(_this.outlinePass);

            //获取.setPixelRatio()设置的设备像素比
            let pixelRatio = _this.renderer.getPixelRatio();
            const FXAAPass = new ShaderPass( FXAAShader );
            // width、height是canva画布的宽高度
            FXAAPass.uniforms.resolution.value.x = 1 /(window.innerWidth*pixelRatio);
            FXAAPass.uniforms.resolution.value.y = 1 /(window.innerHeight*pixelRatio);
            _this.composer.addPass( FXAAPass );
            // width、height是canva画布的宽高度
            const smaaPass = new SMAAPass(window.innerWidth * pixelRatio, window.innerHeight * pixelRatio);
            _this.composer.addPass(smaaPass);

            // //创建伽马校正后处理通道，防止模型变暗
            const gammaPass = new ShaderPass(GammaCorrectionShader)
            _this.composer.addPass(gammaPass)
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.upperhtmldimension,_this.downhtmldimension,_this.outerhtmldimension]);
              // const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                // 声明一个三维向量用来表示某个坐标
                // const worldPosition = new THREE.Vector3();
                // 获取mesh的世界坐标，你会发现mesh的世界坐标受到父对象group的.position影响
                // intersects[0].object.getWorldPosition(worldPosition);
                // console.log('世界坐标',worldPosition);
                // console.log('本地坐标',intersects[0].object.position);
                console.log("射线器返回对象", intersects);

                if(intersects[0].object.name == 'upperhtmldimension'){
                  _this.Product_introduce = {
                    text:'',
                    en_text:'',
                    image:'',
                  }
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var oldT = { //旧的聚焦位置
                    x: _this.controls.target.x,
                    y: _this.controls.target.y,
                    z: _this.controls.target.z,
                  }
                  var newT = { //新的聚焦位置
                    x: -intersects[0].object.position.x*10,
                    y: intersects[0].object.position.y*10,
                    z: intersects[0].object.position.z*10,
                  }
                  var newP = { //新的相机位置
                    x: -intersects[0].object.position.x*10,
                    y: 150,
                    z: 20,
                  }
                  _this.upperhtmldimension.visible = false
                  _this.oldP = oldP
                  _this.tweenCamera(oldP, oldT, newP, newT);
                  _this.dialogVisible = true
                  // _this.Product_introduce = _this.Product_info.upper
                  _this.$nextTick(()=>{
                    _this.Product_introduce = _this.Product_info.upper
                  })
                }else if(intersects[0].object.name == 'downhtmldimension'){
                  _this.Product_introduce = {
                    text:'',
                    en_text:'',
                    image:'',
                  }
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var oldT = { //旧的聚焦位置
                    x: _this.controls.target.x,
                    y: _this.controls.target.y,
                    z: _this.controls.target.z,
                  }
                  var newT = { //新的聚焦位置
                    x: intersects[0].object.position.x,
                    y: intersects[0].object.position.y,
                    z: -intersects[0].object.position.z,
                  }
                  var newP = { //新的相机位置
                    x: intersects[0].object.position.x,
                    y: -40,
                    z: 140,
                  }
                  _this.downhtmldimension.visible = false
                  _this.oldP = oldP
                  _this.tweenCamera(oldP, oldT, newP, newT);
                  _this.dialogVisible = true
                  _this.$nextTick(()=>{
                    _this.Product_introduce = _this.Product_info.down
                  })
                }else if(intersects[0].object.name == 'outerhtmldimension'){ // outerhtmldimension
                  _this.Product_introduce = {
                    text:'',
                    en_text:'',
                    image:'',
                  }
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var oldT = { //旧的聚焦位置
                    x: _this.controls.target.x,
                    y: _this.controls.target.y,
                    z: _this.controls.target.z,
                  }
                  var newT = { //新的聚焦位置
                    x: -intersects[0].object.position.x*10,
                    y: intersects[0].object.position.y*10,
                    z: intersects[0].object.position.z*10,
                  }
                  var newP = { //新的相机位置
                    x: -intersects[0].object.position.x*10,
                    y: intersects[0].object.position.y,
                    z: 150,
                  }
                  _this.outerhtmldimension.visible = false
                  _this.oldP = oldP
                  _this.tweenCamera(oldP, oldT, newP, newT);
                  _this.dialogVisible = true
                  // _this.Product_introduce = _this.Product_info.outer
                  _this.$nextTick(()=>{
                    _this.Product_introduce = _this.Product_info.outer
                  })
                }else if(intersects[0].object.name == 'removehtmldimension'){ // outerhtmldimension
                  // if(_this.cebanstatus){ //侧板存在
                    // _this.model.getObjectByName("ceban").visible = !_this.cebanstatus
                    _this.model.getObjectByName("mesh_3").visible = !_this.cebanstatus
                    _this.model.getObjectByName("mesh_3_1").visible = !_this.cebanstatus
                    _this.model.getObjectByName("mesh_4").visible = !_this.cebanstatus
                    _this.model.getObjectByName("mesh_4_1").visible = !_this.cebanstatus
                    _this.model.getObjectByName("mesh_6").visible = !_this.cebanstatus
                    _this.cebanstatus = !_this.cebanstatus
                  // }else{ //侧板不存在
                    // _this.model.getObjectByName("ceban").visible = !_this.cebanstatus
                  // }
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var oldT = { //旧的聚焦位置
                    x: _this.controls.target.x,
                    y: _this.controls.target.y,
                    z: _this.controls.target.z,
                  }
                  var newT = { //新的聚焦位置
                    x: -intersects[0].object.position.x,
                    y: intersects[0].object.position.y,
                    z: intersects[0].object.position.z,
                  }
                  var newP = { //新的相机位置
                    x: 146,
                    y: -10,
                    z: 65,
                  }
                  // _this.tweenCamera(oldP, oldT, newP, newT);

                }
              }else{
                console.log('no select');
              }
            })
          },

          /**
           * @description 关闭弹窗
           */
          handleClose(done) {
            let _this = this
            done()
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: _this.oldP.x,
              y: _this.oldP.y,
              z: _this.oldP.z,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
            _this.upperhtmldimension.visible = true
            _this.downhtmldimension.visible = true
            _this.outerhtmldimension.visible = true
          },
          removeceban(){ //移除侧板标注
            let _this = this
            if(_this.changecebanid == 1){
              _this.model.getObjectByName("ceban").visible = !_this.cebanstatus
            }else if(_this.changecebanid == 2){
              _this.model.getObjectByName("xiamocutiaoceban").visible = !_this.cebanstatus
            }
            // _this.model.getObjectByName("mesh_3_1").visible = !_this.cebanstatus
            // _this.model.getObjectByName("mesh_4").visible = !_this.cebanstatus
            // _this.model.getObjectByName("mesh_4_1").visible = !_this.cebanstatus
            _this.cebanstatus = !_this.cebanstatus

            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: 160,
              y: -20,
              z: 20
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // this.model.getObjectByName("shoudogtuishi").visible = false
            // this.model.getObjectByName("shoudongtuilashi").visible = false
            // this.model.getObjectByName("mesh_3").visible = false
            // this.model.getObjectByName("mesh_3_1").visible = false
            // this.model.getObjectByName("mesh_4").visible = false
            // this.model.getObjectByName("mesh_4_1").visible = false
            // this.model.getObjectByName("mesh_6").visible = false
            // 创建精灵材质对象SpriteMaterial
            // const spriteMaterial = new THREE.SpriteMaterial({
            //   color:0x00ffff,//设置颜色
            // });
            // // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            // this.model.add(sprite);
            // console.log(this.camera.position);
            _this.scene.remove(_this.model)
            _this.model.traverse(function (object) {
              if (object.type === 'Mesh') {
                object.geometry.dispose()
                object.material.dispose()
              }
            })
          },
        }
    }
</script>

<style scoped>
  @keyframes scale {
      0% {
          transform: scale(1);
          opacity: .9
      }
      100% {
          transform: scale(2);
          opacity: 0;
      }
  }

  @keyframes scale2 {
      0% {
          transform: scale(1);
          opacity: .9;
      }
      100% {
          transform: scale(4);
          opacity: 0;
      }
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .product_name{
    position: absolute;
    z-index: 10;
    font-size: 18px;
    font-weight: 700;
    top: 14vh;
    left: 4vw;
  }
  div /deep/ .dimensiondom{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ed5a6485;
    /* box-shadow: 0px 0px 10px #004EA1; */
    cursor: pointer;
    pointer-events: auto;
  }
  div /deep/ .dimensiondom::after {
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    content: '';
    background: #ed5a64;
    animation: scale2 2s infinite;
  }
  div /deep/ .dimensiondom::before {
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    content: '';
    background: #ed5a64;
    animation: scale 2s infinite;
  }
  div /deep/ .el-dialog{
    position: absolute !important;
    width: 32% !important;
    right: 5% !important;
    margin-top: 35vh !important;
    border-radius: 20px !important;
  }
  div /deep/ .el-dialog span{
    font-size: 19px;
    font-weight: 700;
  }
  div /deep/ .el-dialog__header{
    padding: 0px;
  }
  .dialogimg{
    width: 100%;
    /* height: 250px; */
    object-fit: cover;
    margin-bottom: 15px;
  }
  @media (max-width:996px) {
    div /deep/ .el-dialog{
      width: 60% !important;
      margin-top: 4vh !important;
    }
  }
  @media (max-width:450px) {
    div /deep/ .el-dialog{
      width: 90% !important;
      margin-top: 4vh !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pcmtmodel.vue